/**
 * O bloco `esocial` que o formulário envia (#302).
 *
 * Com o GFIP vindo preenchido pelo cálculo, o bloco passa a ir quase sempre, e as datas vazias
 * (Início e Fim da Condição, Estabilidade) fazem a API recusar com "Data de início deve ser uma
 * data válida" — depois de o funcionário já ter sido criado pela metade. Data vazia é ausência:
 * não vai. Na criação, nenhum campo vazio vai; na edição, Motivo e GFIP vazios seguem, para a
 * pessoa poder apagá-los.
 *
 * Início da Condição sugerido pela data de admissão (#644): só vai junto de Motivo ou GFIP
 * preenchido (o GFIP calculado pelo cargo conta). Sem eles, o funcionário ganharia um registro
 * eSocial sem sentido. Data digitada pela pessoa vai sempre.
 */

import type { EmployeeFormData } from '../../types/employee';

export type ESocialDoFormulario = EmployeeFormData['esocial'];

const CAMPOS_DE_DATA = ['inicioCondEsocial', 'fimCondEsocial', 'estabilidade'] as const;

export interface OpcoesDoEnvio {
  /** O Início da Condição veio da admissão e a pessoa não mexeu nele. */
  inicioSugerido?: boolean;
}

function temValor(valor: string | undefined): boolean {
  return (valor ?? '').trim() !== '';
}

export function esocialParaEnvio(
  esocial: Partial<ESocialDoFormulario> | undefined,
  modo: 'criacao' | 'edicao',
  { inicioSugerido = false }: OpcoesDoEnvio = {}
): Partial<ESocialDoFormulario> | undefined {
  if (!esocial) return undefined;

  const soltaInicio = inicioSugerido && !temValor(esocial.motivo) && !temValor(esocial.gfip);

  const enviado: Partial<ESocialDoFormulario> = {};
  for (const [campo, valor] of Object.entries(esocial) as Array<[keyof ESocialDoFormulario, string | undefined]>) {
    if (valor === undefined) continue;
    if (campo === 'inicioCondEsocial' && soltaInicio) continue;
    const vazio = valor.trim() === '';
    const ehData = (CAMPOS_DE_DATA as readonly string[]).includes(campo);
    if (vazio && (ehData || modo === 'criacao')) continue;
    enviado[campo] = valor;
  }

  return Object.keys(enviado).length > 0 ? enviado : undefined;
}
